import { Result } from './model';
export var asMatching = function (re, message) {
    return function (value, path) { return typeof value === 'string' && re.test(value)
        ? Result.ok(value)
        : Result.error([{ path: path, expected: message || "string matching " + re }]); };
};
